
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class PendingOrderJobSettingsGrid extends Serenity.EntityGrid<PendingOrderJobSettingsRow, any> {
        protected getColumnsKey() { return PendingOrderJobSettingsColumns.columnsKey; }
        protected getDialogType() { return PendingOrderJobSettingsDialog; }
        protected getIdProperty() { return PendingOrderJobSettingsRow.idProperty; }
        protected getInsertPermission() { return PendingOrderJobSettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return PendingOrderJobSettingsRow.localTextPrefix; }
        protected getService() { return PendingOrderJobSettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}